import { ACCOUNT_SETTINGS_BANNER_HEADER_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[ACCOUNT_SETTINGS_BANNER_HEADER_MODULE_ID]: {
		moduleType: 'bannerHeader',
		bannerImageText: 'Account Settings',
	},
}
